"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableHeading_1 = __importDefault(require("components/common/table/TableHeading"));
var UsersTableRow_1 = __importDefault(require("./UsersTableRow"));
var ClientsTable = function (_a) {
    var sort = _a.sort, data = _a.data, onChangeSort = _a.onChangeSort, onDelete = _a.onDelete;
    return (react_1.default.createElement("div", { className: 'table' },
        react_1.default.createElement("div", { className: 'table__head flex flex-row' },
            react_1.default.createElement(TableHeading_1.default, { name: 'First Name', sortable: true, active: sort.name === 'First Name', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Last Name', sortable: true, active: sort.name === 'Last Name', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Email Address', sortable: true, active: sort.name === 'Email Address', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Action', sortable: false })),
        react_1.default.createElement("div", { className: 'table__body' },
            data.length > 0 &&
                data.map(function (user) { return (react_1.default.createElement(UsersTableRow_1.default, { onDelete: onDelete, key: user.id, data: user })); }),
            data.length <= 0 &&
                react_1.default.createElement("p", { className: 'table__empty' }, "There are no users to show"))));
};
exports.default = ClientsTable;
